import React from 'react';
import cx from 'classnames';
import { getConvertedDistance, getConvertedVerticalDistance } from '../../utils';
import { Icons } from '../Icons';
export const FlightCard = ({ data, onClick, languageData, unitProfile, operationIcon, aircraftIcon, }) => {
    const { distanceUnit, distanceVerticalUnit } = unitProfile;
    const onClickHandle = () => {
        if (onClick) {
            if (data) {
                onClick(data.id);
            }
            else {
                onClick(-1);
            }
        }
    };
    if (!data) {
        return (React.createElement("div", { className: "flight-card", onClick: onClickHandle },
            React.createElement("div", { className: "flight-card_row" },
                React.createElement("div", { className: "flight-card_iconInfo" },
                    React.createElement("span", { className: "flight-card_title" }, languageData.removeFlight)))));
    }
    const model = data.aircraftType ? data.aircraftType : '—';
    const opName = `ad-${data.operationType.toLowerCase()}`;
    const acIcon = data.aircraftCategory
        ? `ic-ac-${data.aircraftCategory.toLowerCase()}`
        : 'ic-ac-unknown';
    const checkIfDataExist = (key) => {
        return data && typeof data.pca !== 'undefined' && typeof data.pca[key] !== 'undefined'
            ? data.pca[key]
            : null;
    };
    return (React.createElement("div", { className: "flight-card", onClick: onClickHandle },
        React.createElement("div", { className: "flight-card_row" },
            React.createElement("div", { className: "flight-card_iconInfo" },
                operationIcon ? (operationIcon) : (React.createElement(Icons, { iconName: `ic-${opName}`, size: 20, className: cx('flight-card_icon', opName) })),
                React.createElement("span", { className: "flight-card_title" }, data.acid)),
            checkIfDataExist('displayTime') && React.createElement("div", null, data.pca.displayTime)),
        React.createElement("div", { className: "flight-card_row" },
            React.createElement("div", { className: "flight-card_iconInfo" },
                aircraftIcon ? (aircraftIcon) : (React.createElement(Icons, { iconName: acIcon, size: 20, className: "flight-card_icon" })),
                React.createElement("div", null,
                    React.createElement("span", { className: "flight-card_category" }, languageData.model),
                    React.createElement("span", { className: "flight-card_value" }, model))),
            React.createElement("div", null,
                React.createElement("span", { className: "flight-card_category" }, languageData.pca),
                checkIfDataExist('slantDistance') && (React.createElement("span", { className: "flight-card_value" }, getConvertedDistance(data.pca.slantDistance, distanceUnit, 1))),
                checkIfDataExist('verticalDistance') && (React.createElement("span", { className: "flight-card_value" }, getConvertedVerticalDistance(data.pca.verticalDistance, distanceVerticalUnit, 1))),
                checkIfDataExist('elevationAngle') && (React.createElement("span", { className: "flight-card_value" }, `${data.pca.elevationAngle}°`))))));
};
//# sourceMappingURL=FlightCard.js.map